import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import { MenuContainer, MenuLine, Icon } from './Styles'

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 45px;
  height: 45px;
  flex-direction: column;
  cursor: pointer;
  margin-right:4px;
  margin-left: 8px;
  @media (min-width: 768px) {
    display: none;
  }
`


const IconToShow = {
  open: (<MenuContainer>
    <MenuLine />
    <MenuLine />
    <MenuLine />
  </MenuContainer>),
  close: <Icon src="/assets/whiteClose.svg" alt="close" />,
  back: <Icon src="/assets/whiteBack.svg" alt="close" />,
}

const MenuButton = props => (
  <Container onClick={props.onClick}>
    {IconToShow[props.icon]}
  </Container>
)

MenuButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.string.isRequired
}

export default MenuButton



// WEBPACK FOOTER //
// ./src/Components/ParentPlatform/Navbar/MenuButton.jsx